<div class="projects-grid-export-pane-component" [class.close]="shouldClose" [class.canClose]="canClose">
  <steps-manager *ngIf="canClose" [displayCloseButton]="true" [stepsCount]="stepsCount" [currentStep]="currentStep" (onCloseClicked)="onCloseClicked()"></steps-manager>
  <div class="projects-grid-export-pane-container">

    <div class="upper-text">
      <h2>{{'projectsGridExportPane.exports' | translate | uppercase}}</h2>
      <h3>{{'projectsGridExportPane.selectTypeOfExport' | translate}}</h3>
    </div>

    <kendo-dropdownlist [data]="exportOptions"
                        textField="description"
                        valueField="oid"
                        [valuePrimitive]="true"
                        [(ngModel)]="selectedExportType">
    </kendo-dropdownlist>

    <div class="buttons-container">
      <button kendoButton (click)="exportClicked()" [disabled]="selectedExportType < 1">{{'projectsGridExportPane.buttonExport' | translate}}</button>
    </div>
  </div>
</div>
